module.exports = __webpack_public_path__ + "img/rebuild_liao_pad_bg.678cfec3.png";